export default __webpack_public_path__ + "assets/images/aistudio/empty_state/3d684ec945a6f5ccced94ae59ebeee3a.png";